export default __webpack_public_path__ + "static/media/service-2.eefa0312.jpg";